
import { motion } from 'framer-motion';

const ServicesShowcase = () => {
  const services = [
    {
      title: 'Ocean Freight',
      description: 'Comprehensive sea shipping solutions for cargo of all sizes across global routes.',
      icon: 'ri-ship-line',
      image: 'https://public.readdy.ai/ai/img_res/4f0edfb5c826403050ecc60df28faa43.jpg',
      large: true,
    },
    {
      title: 'Air Freight',
      description: 'Fast and reliable air cargo services for time-sensitive shipments worldwide.',
      icon: 'ri-plane-line',
      image: 'https://readdy.ai/api/search-image?query=modern%20white%20cargo%20airplane%20flying%20through%20clear%20blue%20sky%20with%20soft%20clouds%20professional%20aviation%20photography%20showing%20sleek%20aircraft%20design%20representing%20fast%20efficient%20air%20freight%20logistics%20and%20express%20shipping%20services&width=800&height=400&seq=service-air-001&orientation=landscape',
      large: false,
    },
    {
      title: 'Road Transport',
      description: 'Efficient ground transportation with real-time tracking and flexible delivery options.',
      icon: 'ri-truck-line',
      image: 'https://readdy.ai/api/search-image?query=modern%20white%20delivery%20truck%20driving%20on%20smooth%20highway%20with%20green%20landscape%20background%20professional%20logistics%20photography%20showing%20clean%20commercial%20vehicle%20representing%20reliable%20road%20freight%20transportation%20and%20ground%20shipping%20services&width=800&height=400&seq=service-road-001&orientation=landscape',
      large: false,
    },
    {
      title: 'Rail Logistics',
      description: 'Cost-effective rail freight solutions for bulk cargo and long-distance transport.',
      icon: 'ri-train-line',
      image: 'https://readdy.ai/api/search-image?query=long%20freight%20train%20with%20cargo%20containers%20traveling%20through%20scenic%20countryside%20landscape%20professional%20railway%20logistics%20photography%20showing%20efficient%20rail%20transportation%20with%20natural%20background%20representing%20sustainable%20bulk%20cargo%20shipping%20solutions&width=800&height=900&seq=service-rail-001&orientation=portrait',
      large: true,
    },
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-16"
        >
          <div className="w-20 h-1 bg-primary-green mb-6"></div>
          <h2 className="font-heading text-4xl lg:text-5xl text-gray-900 font-bold mb-4">Our Services</h2>
          <p className="text-lg text-gray-600 max-w-2xl">
            Comprehensive logistics solutions tailored to your shipping needs across all transport modes.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {services.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className={`group relative overflow-hidden rounded-xl cursor-pointer ${
                service.large ? 'lg:row-span-2' : ''
              }`}
              style={{ height: service.large ? '600px' : '290px' }}
            >
              <div
                className="absolute inset-0 bg-cover bg-center transition-transform duration-500 group-hover:scale-110"
                style={{ backgroundImage: `url(${service.image})` }}
              ></div>
              <div className="absolute inset-0 bg-black/50"></div>
              <div className="absolute bottom-0 left-0 right-0 p-8 text-white">
                <div className="w-14 h-14 flex items-center justify-center bg-primary-green rounded-xl mb-4">
                  <i className={`${service.icon} text-2xl`}></i>
                </div>
                <h3 className="font-heading text-2xl font-bold mb-3">{service.title}</h3>
                <p className="text-gray-200 mb-4">{service.description}</p>
                <a
                  href="/services"
                  className="inline-flex items-center text-primary-green font-semibold hover:gap-2 transition-all whitespace-nowrap cursor-pointer"
                >
                  Learn More
                  <i className="ri-arrow-right-line ml-1"></i>
                </a>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesShowcase;
